<template>
  <div class="web-head row clearfix">
    <div class="col-lg-4">
      <router-link to="/index">
        <span style="margin-right: 16px;color:#666;font-weight: 800">
        <img style="height: 50px;width: 50px" src="../assets/images/logo.png">
      </span>
        <span style="font-size:40px">
        广州宝莉科技
        </span>
      </router-link>
    </div>
    <div class="col-lg-8 menu-content">
      <router-link to="/index">首页</router-link>
<!--      <router-link to="/about">关于</router-link>-->
<!--      <router-link to="/experience">体验</router-link>-->
<!--      <a href="https://www.zhipin.com/gongsir/cce28d4330c3a94e33193927.html?ka=company-jobs">招聘</a>-->
<!--      <router-link to="/cooperation">合作</router-link>-->
    </div>
  </div>
</template>

<script>
  export default {
    name: "yw_head"
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/yw_head.vue